import {FormDate} from './form-date.class';
import {Inkomsttyp} from '../enums/inkomsttyp.enum';

export class ValutakursParam {
  private readonly valuta: string;
  private readonly valutaSkatt: string;

  private readonly datum = {
    ar: '',
    manad: '',
    dag: '',
  };

  constructor(valuta: string, valutaSkatt: string, utbetalningsdatum: any) {
    this.valuta = valuta;
    this.valutaSkatt = valutaSkatt;

    this.datum.ar = utbetalningsdatum.year;
    this.datum.manad = utbetalningsdatum.month === '-1' ? null : this.slice(utbetalningsdatum.month);
    this.datum.dag = utbetalningsdatum.day === '-1' ? null : this.slice(utbetalningsdatum.day);
  }

  getValuta(): string {
    return this.valuta;
  }

  getValutaSkatt(): string {
    return this.valutaSkatt;
  }

  isValutaSkattValid(): boolean {
    return this.valutaSkatt !== undefined && this.valutaSkatt !== null && this.valutaSkatt !== '';
  }

  getDatum() {
    return this.datum;
  }

  private slice(value): string {
    return ('0' + value.toString()).slice(-2);
  }
}


export class Valuta {
  valuta?: string;
  valutakurs?: string;
  belopp?: string;

  constructor(valuta: Valuta) {
    this.valuta = valuta.valuta === undefined || valuta.valuta === null ? null : valuta.valuta;
    this.valutakurs = valuta.valutakurs === undefined || valuta.valutakurs === null ? null : valuta.valutakurs;
    this.belopp = valuta.belopp === undefined || valuta.belopp === null ? null : valuta.belopp.replace(/\s/g, '');
  }
}

export class FormUnderlag {
  id: number;
  inkomsttyp: Inkomsttyp;
  land: string;
  isUtbetald: boolean;
  utbetalningsdatum = new FormDate({ year: null, month: null, day: null});
  beloppUtbetald = new Valuta({ valuta: null, belopp: null});
  isUtlandskSkatt: boolean;
  utlandskSkatt = new Valuta( { valuta: null, belopp: null});
  valutadag: string;
  bankdag: boolean;

  constructor(
    id: number,
    inkomsttyp: Inkomsttyp,
    land: string,
    isUtbetald: boolean,
    utbetalningsdatum: FormDate,
    isUtlandskSkatt: boolean,
    utbetaldBelopp: Valuta,
    utlandskSkatt: Valuta,
    valutadag: string = null,
    bankdag = false) {
    this.id = id;
    this.inkomsttyp = inkomsttyp;
    this.land = land;
    this.isUtbetald = isUtbetald;
    this.utbetalningsdatum = new FormDate(utbetalningsdatum);
    this.isUtlandskSkatt = isUtlandskSkatt;
    this.beloppUtbetald = new Valuta(utbetaldBelopp);
    this.utlandskSkatt = new Valuta(utlandskSkatt);
    this.valutadag = valutadag === null ? this.utbetalningsdatum.getDate() : valutadag;
    this.bankdag = bankdag;
  }

  public static createUnderlag(underlag: FormUnderlag): FormUnderlag {
    return new FormUnderlag(
      underlag.id,
      underlag.inkomsttyp,
      underlag.land,
      underlag.isUtbetald,
      underlag.utbetalningsdatum,
      underlag.isUtlandskSkatt,
      underlag.beloppUtbetald,
      underlag.utlandskSkatt,
      underlag.valutadag,
      underlag.bankdag
    );
  }
}

